import "core-js/modules/es.array.concat.js";
export function constructFieldKey(name, id) {
  return "".concat(name, "__").concat(id);
}